// Lazy-load the Google Maps JS API exactly once. Returns a Promise<google> that
// resolves once the script is on the page. Subsequent calls reuse the same
// load promise, so multiple Map cards on the page don't re-inject.

let loaderPromise = null;

export function loadGoogleMaps(apiKey) {
    if (typeof window === "undefined") return Promise.reject(new Error("no window"));
    if (window.google && window.google.maps) return Promise.resolve(window.google);
    if (loaderPromise) return loaderPromise;

    loaderPromise = new Promise((resolve, reject) => {
        if (!apiKey) {
            reject(new Error("Google Maps API key is missing"));
            return;
        }
        const existing = document.getElementById("travelchat-gmaps-script");
        if (existing) {
            existing.addEventListener("load", () => resolve(window.google));
            existing.addEventListener("error", reject);
            return;
        }
        const s = document.createElement("script");
        s.id = "travelchat-gmaps-script";
        s.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=weekly`;
        s.async = true;
        s.defer = true;
        s.onload = () => resolve(window.google);
        s.onerror = (e) => reject(e);
        document.head.appendChild(s);
    });
    return loaderPromise;
}

// Desaturated, B&W-friendly map style. Removes most colored fills/labels and
// keeps the canvas readable.
export const BW_MAP_STYLE = [
    { elementType: "geometry", stylers: [{ saturation: -100 }, { lightness: 5 }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#525252" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#FFFFFF" }] },
    { featureType: "administrative", elementType: "geometry", stylers: [{ visibility: "off" }] },
    { featureType: "poi", stylers: [{ visibility: "off" }] },
    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#EFEFEF" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#E5E5E5" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#D4D4D4" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#E8EEF2" }] },
];
